export const initialMinDate = '1800-01-01T00:00:00';
